import React from 'react';
import { useStore } from 'zustand';

import { ScanMiniRoundDataState, ScanMiniRoundDataStoreApi } from '../stores/createScanMiniRoundDataStore';

export { selectBpm, selectMelData, selectRecordingInfo, selectSignalData } from '../stores/createScanMiniRoundDataStore';

export const ScanMiniRoundDataContext: React.Context<ScanMiniRoundDataStoreApi | null> =
  React.createContext<ScanMiniRoundDataStoreApi | null>(null);

export function useScanMiniRoundDataStore<U>(selector: (s: ScanMiniRoundDataState) => U): U {
  const api = React.useContext(ScanMiniRoundDataContext);
  if (!api) {
    throw new Error('useScanMiniRoundDataStore must be used within ScanMiniRoundDataContext.Provider');
  }
  return useStore(api, selector);
}
